import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { API_URL } from '../constants';
import { IPagedResults } from '../core/interfaces';
import { BaseDataService, DataService } from '../core/services';

@Injectable()
export class UserService extends BaseDataService {
    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    public getUsersList(page: number, pageSize: number = 10): Observable<IPagedResults<any>> {
        let url = `User/GetAll`;
        return super.getAll<any>(url);
    }

    public getActiveUsersList(): Observable<IPagedResults<any>> {
        let url = `User/GetAllActiveUsers`;
        return super.getAll<any>(url);
    }

    public getUsersByAccountList(id: number): Observable<IPagedResults<any>> {
        let url = `User/GetByAccountId?id=${id}`;
        return super.getAll<any>(url);
    }

    public getEmails(id: number) {
        let url = `User/GetEmails?id=${id}`;
        return super.getById<any>(url);
    }

    public resendCreateUserConfirmation(data) {
        let url = `User/ResendCreateUserConfirmation`;
        return super.save<any>(url, data);
    }

    public getUser(id?: number): Observable<any> {
        let url = `User/Get?id=${id}`;
        return super.getAll<any>(url);
    }

    public saveUser(data) {
        let url = `User/Save`;
        return super.save<any>(url, data);
    }

    public updateUser(data) {
        let url = `User/Update`;
        return super.put<any>(url, data);
    }

    public deleteUser(data) {
        let url = `User/Delete`;
        return super.save<any>(url, data);
    }

    public GetPdf(accountId?: number): Observable<any> {
        let url = `User/GetPdf?accountId=${accountId}`;
        return super.savePDF<any>(url, 'application/pdf');
    }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts